'use strict';

import {itemModel} from "../models/itemmodel.js";

export class ItemEditCtrl
{
	initialized = false;
	progress = false;
	submitted = false;
	$filter;
	$scope;
	notify;
	jsDataService;
	$http;
	$mdDialog;
	classif = {};
	item = {};
	cfg = {
		field: {},
		maxImages: 4,
		imageFilter: {
			png:true,
			gif:true,
			jpg:true,
			jpeg:true
		}
	};
	
	registerItemUrl;
	flow;
	dragClass = '';
	
	constructor($scope, $filter, $http, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$filter = $filter;
		this.$scope = $scope;
		this.$http = $http;
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		this.jsDataService = jsDataService;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new itemModel(this.jsDataService.get('storeditemData', {}));
		this.cfg.field = this.jsDataService.get('cfgItemFields', {});
		this.cfg.maxImages = this.jsDataService.get('cfgMaxImages', 4);
		this.cfg.imageFilter = this.jsDataService.get('cfgImageFilter', {});
		this.initItemFields();
		this.registerItemUrl = this.jsDataService.get('actionRegisterItemUrl');
	}
	
	$onInit(){
		this.initialized = true;
	}
	
	getLevelArray(level){
		if(isNaN(level)){
			return [];
		}
		let lev = parseInt(level) - 1;
		if(lev < 1){
			return [];
		}
		return [].constructor(lev);
	}
	
	unsetProperty(propName){
		if(typeof(this.item[propName]) !== 'undefined'){
			this.item[propName] = null;
		}
	}
	
	actionStore(){
		const url = this.jsDataService.get('actionSaveUrl');
		if(url){
			this.submitted = true;
			this.progress = true;
			const self = this;
			this.$http({
				url: url,
				method: 'POST',
				responseType: 'json',
				data: this.getItemPostData()
			}).then(function(response){
				self.progress = false;
				if(response.data){
					if(response.data.success){
						if(typeof(response.data.url) !== 'undefined'){
							window.location.href = response.data.url;
						}
						else{
							self.submitted = false;
							if(typeof(response.data.item) !== 'undefined'){
								self.item = new itemModel(response.data.item);
								self.initItemFields();
							}
						}
					}
					else{
						self.submitted = false;
					}
					if(response.data.message){
						self.notify(response.data.message, !response.data.success);
					}
				}
				else{
					self.submitted = false;
					console.log(response);
					self.notify('Communication Error', true);
				}
			}, function(response){
				console.log("HTTP ERROR");
				console.log(response);
				self.notify('Network error, Status: ' + response.status, true);
				self.progress = false;
				self.submitted = false;
			});
		}
	}
	
	getItemPostData(){
		let postData = angular.copy(this.item);
		if(typeof(postData.photos) !== 'undefined'){
			for(let ph of postData.photos){
				if(ph.isFlow){
					delete ph.flowFile;
				}
			}
		}
		return postData;
	}
	
	fieldVisible(fieldName){
		if(typeof(this.cfg.field[fieldName]) === 'undefined' || !this.cfg.field[fieldName].edit){
			return false;
		}
		return true;
	}
	
	fieldRequired(fieldName){
		if(typeof(this.cfg.field[fieldName]) !== 'undefined' && this.cfg.field[fieldName].required){
			return true;
		}
		return false;
	}
	
	initItemFields(){
		if(this.item.initial_type_id > 0 && typeof(this.classif.types) !== 'undefined'){
			for(let c of this.classif.types){
				if(c.id == this.item.initial_type_id){
					this.item.initial_type = c;
					break;
				}
			}
		}
		if(this.item.type_id > 0 && typeof(this.classif.types) !== 'undefined'){
			for(let c of this.classif.types){
				if(c.id == this.item.type_id){
					this.item.type = c;
					break;
				}
			}
		}
		if(this.item.initial_location_id > 0 && typeof(this.classif.locations) !== 'undefined'){
			for(let c of this.classif.locations){
				if(c.id == this.item.initial_location_id){
					this.item.initial_location = c;
					break;
				}
			}
		}
		if(this.item.location_id > 0 && typeof(this.classif.locations) !== 'undefined'){
			for(let c of this.classif.locations){
				if(c.id == this.item.location_id){
					this.item.location = c;
					break;
				}
			}
		}
		if(this.item.initial_status_id > 0 && typeof(this.classif.status) !== 'undefined'){
			for(let c of this.classif.status){
				if(c.id == this.item.initial_status_id){
					this.item.initial_status = c;
					break;
				}
			}
		}
		if(this.item.status_id > 0 && typeof(this.classif.status) !== 'undefined'){
			for(let c of this.classif.status){
				if(c.id == this.item.status_id){
					this.item.status = c;
					break;
				}
			}
		}

//		if(typeof(this.item.photos) === 'undefined'){
//			this.item.photos = [];
//		}
//		else{
//			for(let ph of this.item.photos){
//				ph.isFlow = false;
//				ph.done = true;
//				ph.nrId = ph.file_id;
//			}
//		}
	}
	

	showRegisterButton(){
		return (this.registerItemUrl && this.registerItemUrl !== '');
	}
	
	actionRegister(){
		if(this.showRegisterButton()){
			this.submitted = true;
			this.progress = true;
			const self = this;
			this.$http({
				url: this.registerItemUrl,
				method: 'GET',
				responseType: 'json',
			}).then(function(response){
				self.progress = false;
				if(response.data){
					if(response.data.success){
						if(typeof(response.data.url) !== 'undefined'){
							window.location.href = response.data.url;
						}
						else{
							self.submitted = false;
						}
					}
					else{
						self.submitted = false;
					}
					if(response.data.message){
						self.notify(response.data.message, !response.data.success);
					}
				}
				else{
					self.submitted = false;
					console.log(response);
					self.notify('Communication Error', true);
				}
			}, function(response){
				console.log("HTTP ERROR");
				console.log(response);
				self.notify('Network error, Status: ' + response.status, true);
				self.progress = false;
				self.submitted = false;
			});
		}
	}
	
	imageUploaded($file, $message, $flow){
		if($file.response.success){
			let f = this.$filter('filter')(this.item.photos, {nrId: $file.uniqueIdentifier}, true);
			if(f.length > 0){
				let photo = f.shift();
				photo.file_id = $file.response.fileId;
				photo.done = true;
			}
		}
	}
	
	imageSubmited($files){
		this.flow.upload();
	}
	
	imagesAdded($files){
		if(typeof(this.cfg.maxImages) !== 'undefined' && $files.length > this.cfg.maxImages){
			return false;
		}
		return true;
	}
	
	imageAdded($file){
		const ext = $file.getExtension();
		if(typeof(this.cfg.imageFilter[ext]) === 'undefined' || !this.cfg.imageFilter[ext]){
//			console.log("Extension '" + ext + "' not allowed");
			return false;
		}
		if(typeof(this.cfg.imageSize) !== 'undefined' && $file.size > this.cfg.imageSize){
//			console.log("Size of " + this.cfg.imageSize + " exeded with " + $file.size);
			return false;
		}
		if(!this.activeUpload()){
//			console.log("Max images of " + this.cfg.maxImages + " exeded");
			return false;
		}
		this.addFlowFile($file);
		return true;
	}
	
	imageRemove(image){
		if(image.isFlow){
			image.flowFile.cancel();
		}
		this.item.photos = this.$filter('filter')(this.item.photos, {nrId: '!' + image.nrId}, true);
	}
	
	activeUpload(){
		if(typeof(this.cfg.maxImages) !== 'undefined' && (this.item.photos.length + 1) > this.cfg.maxImages){
			return false;
		}
		return true;
	}
	
	classOnDrag(value){
		if(this.activeUpload()){
			this.dragClass = value;
		}
	}
	
	classOffDrag(value){
		this.dragClass = value;
	}
	
	addFlowFile($file){
		let image = {
			file_id: '0',
			nrId: $file.uniqueIdentifier,
			file_name: $file.name,
			isFlow: true,
			flowFile: $file,
			done: false
		};
		this.item.photos.push(image);
	}
	
	getPhotosData(){
		let data = [];
		for(let ph of this.item.photos){
			let photo = angular.copy(ph);
			if(photo.isFlow){
				delete photo.flowFile;
			}
			data.push(photo);
		}
		return data;
	}
	
	hasPreview(image){
		if(!image.done){
			return false;
		}
		return true;
	}
	
	imagePreview(e, image){
		if(this.hasPreview(image)){
			this.$mdDialog.show({
				controller: "ImagePreviewCtrl",
				templateUrl: 'itemattachments/image_preview.html',
				parent: angular.element(document.body),
				targetEvent: e,
				clickOutsideToClose:true,
				fullscreen: true,
				locals: {
					image: image
				}
			}).then(function(result) {}, function () {});
		}
	}
}

